import { Box } from '@bpba/ui-components';
import { FC, useContext } from 'react';
import { HeaderButton } from './HeaderButton';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { LoginDialogContext } from './login/LoginDialogContext';

type Props = {
  color?: string;
};

export const Login: FC<Props> = ({ color }) => {
  const { isLoggedin, logout } = useUserStatus();
  const loginDialogState = useContext(LoginDialogContext);

  function onClickLogin() {
    loginDialogState?.showDialog();
  }

  return (
    <Box display={'flex'} alignItems="center" width="auto">
      {!isLoggedin && (
        <HeaderButton color={'primary.0'} backgroundColor={color} borderColor={color} onClick={onClickLogin} text="Ingresar" />
      )}
      {isLoggedin && <HeaderButton color={color} backgroundColor="transparent" borderColor={color} onClick={logout} text="Salir" />}
    </Box>
  );
};
